import { Model } from '@vuex-orm/core'
import ClassInvitation from '@/modules/class/models/ClassInvitation'

export default class Student extends Model {
  static entity = 'students'

  static fields() {
    return {
      id: this.string(''),
      email: this.string(''),
      class_invitations: this.hasMany(ClassInvitation, 'student_id')
    }
  }
}
